import { render, staticRenderFns } from "./ContractManager.vue?vue&type=template&id=3a64d986&scoped=true"
import script from "./ContractManager.vue?vue&type=script&lang=js"
export * from "./ContractManager.vue?vue&type=script&lang=js"
import style0 from "./ContractManager.vue?vue&type=style&index=0&id=3a64d986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a64d986",
  null
  
)

export default component.exports